import { render } from "./TestFunctionBackend.vue?vue&type=template&id=2b4659f2"
import script from "./TestFunctionBackend.vue?vue&type=script&lang=js"
export * from "./TestFunctionBackend.vue?vue&type=script&lang=js"

import "./TestFunctionBackend.vue?vue&type=style&index=0&id=2b4659f2&lang=css"

import exportComponent from "/home/franck_boullier/Documents/bitbucket/exchange-app-admin-vue-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__